/* eslint-disable @typescript-eslint/unbound-method */
import { createContext, useContext } from "react";
import { UserService } from "../../../utils/users";

export class UserServiceContextType {
    constructor (public userService: UserService) {}
}

export const UserServiceContext = createContext<UserServiceContextType | undefined>(undefined);

export const useUserServiceContext = (): UserServiceContextType => {
    const context = useContext(UserServiceContext);
    if (!context) {
        throw new Error("useContext returned an undefined context for the UserServiceContext");
    }
    return context;
};